import { render, staticRenderFns } from "./MicrosoftIntegration.vue?vue&type=template&id=c6fc2756&scoped=true&"
import script from "./MicrosoftIntegration.vue?vue&type=script&lang=ts&"
export * from "./MicrosoftIntegration.vue?vue&type=script&lang=ts&"
import style0 from "./MicrosoftIntegration.vue?vue&type=style&index=0&id=c6fc2756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6fc2756",
  null
  
)

export default component.exports